export const translations = {
  uz: {
    nav: {
      home: 'Bosh Sahifa',
      products: 'Mahsulotlar',
      about: 'Biz Haqimizda',
      news: 'Yangiliklar',
      contact: 'Biz Bilan Bog\'lanish'
    },
    pages: {
      home: {
        title: 'Bruce - Zamonaviy Yechimlar',
        subtitle: 'Yuqori sifatli mahsulotlar va xizmatlar',
        featuredProducts: 'Mashhur Mahsulotlar',
        featuredProductsSubtitle: 'Eng sifatli va mashhur mahsulotlarimiz bilan tanishing',
        latestNews: 'So\'nggi Yangiliklar',
        latestNewsSubtitle: 'Kompaniyamiz haqida eng so\'nggi yangiliklar va ma\'lumotlar',
        whyChooseUs: 'Nima uchun bizni tanlaysiz?',
        whyChooseUsSubtitle: 'Yuqori sifat, ishonchli xizmat va professional yondashuv bilan xizmat ko\'rsatamiz',
        ourServices: 'Bizning Xizmatlarimiz',
        productsTitle: 'Mahsulotlar',
        newsTitle: 'Yangiliklar',
        allProducts: 'Barcha Mahsulotlar',
        allNews: 'Barcha Yangiliklar',
        noProducts: 'Mahsulot topilmadi',
        noNews: 'Yangilik topilmadi',
        featured: 'Asosiy',
        readMore: 'Batafsil'
      },
      products: {
        title: 'Mahsulotlar',
        subtitle: 'Yuqori sifatli va ishonchli mahsulotlarni kashf eting. Har bir mahsulot professional standartlarda tayyorlangan.',
        ourProducts: 'Bizning Mahsulotlarimiz',
        allProducts: 'Barcha Mahsulotlar',
        allCategories: 'Barcha kategoriyalar',
        category: 'Kategoriya',
        price: 'Narx',
        addToCart: 'Savatga qo\'shish',
        viewDetails: 'Batafsil ko\'rish',
        noProducts: 'Mahsulot topilmadi',
        noProductsDetails: 'hech qanday mahsulot topilmadi.',
        productsFound: 'mahsulot topildi',
        inCategory: 'kategoriyasida',
        searchQuery: 'so\'rovi bo\'yicha',
        searchPlaceholder: 'Mahsulot qidirish...',
        filters: 'Filtrlar',
        clearFilters: 'Filtrlarni tozalash',
        sort: 'Saralash',
        sortByName: 'Nom bo\'yicha',
        sortPriceAsc: 'Narx: arzon → qimmat',
        sortPriceDesc: 'Narx: qimmat → arzon',
        sortNewest: 'Eng yangilari',
        ctaTitle: 'Qiziqtirgan mahsulot topmadingizmi?',
        ctaDescription: 'Biz bilan bog\'laning va sizga mos mahsulotni birga topamiz. Professional konsultatsiya bepul!',
        backHome: 'Bosh Sahifaga qaytish',
        pagination: {
          previous: 'Oldingi',
          next: 'Keyingi',
          page: 'Sahifa',
          of: 'dan',
          showing: 'Ko\'rsatilmoqda',
          to: 'dan',
          results: 'natija'
        },
        features: 'Mahsulot Xususiyatlari',
        reviews: 'Mijoz Sharhlari',
        noReviews: 'Bu mahsulot uchun hali sharh yo\'q. Birinchi sharhni siz qoldiring!',
        otherProducts: 'Boshqa Mahsulotlar',
        orderModal: {
          title: 'Sotib Olish',
          firstName: 'Ism',
          lastName: 'Familiya',
          phone: 'Telefon Raqami',
          cancel: 'Bekor Qilish',
          submit: 'Yuborish',
          success: 'Buyurtmangiz muvaffaqiyatli qabul qilindi! Biz siz bilan bog\'lanamiz.',
          error: 'Buyurtmani olishda xatolik yuz berdi.'
        },
        reviewModal: {
          title: 'Sharh Qoldirish',
          name: 'Ismingiz',
          comment: 'Sharhingiz',
          rating: 'Reyting (1-5)',
          cancel: 'Bekor Qilish',
          submit: 'Sharh Qoldirish',
          success: 'Izohingiz muvaffaqiyatli qo\'shildi!',
          error: 'Izoh qo\'shishda xatolik yuz berdi.'
        }
      },
      about: {
        title: 'Biz Haqimizda',
        subtitle: 'Bruce Tank kompaniyasi - sizning ishonchli hamkoringiz. Professional yondashuv va yuqori sifat bilan xizmat ko\'rsatamiz.',
        category: 'Haqimizda',
        ourMission: 'Bizning Missiyamiz',
        ourVision: 'Bizning Vizionimiz',
        ourTeam: 'Bizning Jamoa',
        experience: 'Tajriba',
        clients: 'Mijozlar',
        projects: 'Loyihalar',
        noData: 'Ma\'lumot topilmadi',
        noDataDescription: 'Haqimizda bo\'limida hali ma\'lumot qo\'shilmagan.',
        addDataHint: 'Admin paneldan ma\'lumot qo\'shishingiz mumkin.',
        feature1: 'Sifat',
        feature2: 'Ishonch',
        feature3: 'Professional',
        ourValues: 'Bizning Qadriyatlarimiz',
        valuesDescription: 'Biz ushbu qadriyatlar asosida ishlaymiz va mijozlarimizga xizmat ko\'rsatamiz',
        value1Title: 'Maqsadga Yo\'nalganlik',
        value1Description: 'Har bir loyihada aniq maqsadlar qo\'yamiz va ularga erishamiz',
        value2Title: 'Ishonch',
        value2Description: 'Mijozlarimiz bilan uzoq muddatli ishonchli munosabatlar quramiz',
        value3Title: 'Innovatsiya',
        value3Description: 'Eng yangi texnologiyalar va usullarni qo\'llaymiz',
        value4Title: 'Sifat',
        value4Description: 'Har bir mahsulotda yuqori sifat standartlariga amal qilamiz',
        achievements: 'Bizning Yutuqlarimiz',
        achievementsSubtitle: 'Raqamlar bilan ifodalanadigan muvaffaqiyat va mijozlar ishonchi',
        yearsExperience: 'Yillik Tajriba',
        happyClients: 'Baxtli Mijozlar',
        productTypes: 'Mahsulot Turlari',
        support: 'Qo\'llab-quvvatlash'
      },
      news: {
        title: 'Yangiliklar',
        subtitle: 'Kompaniyamiz faoliyati va sohada sodir bo\'layotgan yangiliklar haqida ma\'lumot oling.',
        readMore: 'Batafsil o\'qish',
        publishedOn: 'Nashr etilgan',
        noNews: 'Yangiliklar mavjud emas',
        noNewsDescription: 'Hozircha yangiliklar yo\'q. Tez orada yangi ma\'lumotlar bilan qaytamiz!',
        backToNews: 'Yangiliklarni ko\'rish',
        featured: 'Asosiy Yangilik',
        readTime: '2 daqiqa',
        available: 'yangilik mavjud',
        loadError: 'Yangiliklar yuklanishda xatolik yuz berdi',
        ctaTitle: 'Yangiliklar haqida birinchi bo\'lib xabardor bo\'ling',
        ctaDescription: 'Bizning ijtimoiy tarmoqlarda kuzatib boring va muhim yangilikların o\'tkazib yubormang!'
      },
      contact: {
        title: 'Biz Bilan Bog\'lanish',
        subtitle: 'Savollaringiz bormi? Biz bilan bog\'laning',
        name: 'Ism',
        email: 'Email',
        phone: 'Telefon',
        message: 'Xabar',
        send: 'Xabar Yuborish',
        address: 'Manzil',
        workingHours: 'Ish vaqti',
        monday: 'Dushanba',
        friday: 'Juma',
        saturday: 'Shanba',
        sunday: 'Yakshanba',
        contactInfo: 'Bog\'lanish Ma\'lumotlari'
      }
    },
    footer: {
      description: 'Yuqori sifatli va ishonchli mahsulotlar bilan B2B va B2C mijozlarimizga xizmat ko\'rsatamiz. Bizning mahsulotlarimiz zamonaviy texnologiyalar asosida ishlab chiqariladi.',
      quickLinks: 'Tezkor Havolalar',
      services: 'Xizmatlarimiz',
      home: 'Asosiy',
      about: 'Biz haqimizda',
      products: 'Mahsulotlar',
      news: 'Yangiliklar',
      contact: 'Aloqa',
      b2bSolutions: 'B2B yechimlar',
      b2cProducts: 'B2C mahsulotlar',
      technicalSupport: 'Texnik yordam',
      consulting: 'Maslahat xizmati',
      delivery: 'Yetkazib berish',
      copyright: 'Barcha huquqlar himoyalangan.',
      privacyPolicy: 'Maxfiylik siyosati',
      termsOfUse: 'Foydalanish shartlari',
      developer: 'Ishlab chiquvchi:'
    },
    common: {
      loading: 'Yuklanmoqda...',
      error: 'Xatolik yuz berdi',
      tryAgain: 'Qayta urinish',
      readMore: 'Batafsil',
      contactUs: 'Biz bilan bog\'laning',
      backToHome: 'Bosh sahifaga qaytish',
      backHome: 'Bosh sahifaga qaytish',
      reload: 'Qayta yuklash',
      search: 'Qidirish',
      filter: 'Saralash',
      sort: 'Tartibga solish',
      featured: 'Asosiy',
      inStock: 'Omborda mavjud',
      outOfStock: 'Omborda yo\'q',
      telegram: 'Telegram',
      instagram: 'Instagram',
      productVideo: 'Mahsulot videosi',
      videoLoading: 'Video yuklanmoqda...',
      openOnYouTube: 'YouTube\'da ochish',
      watchVideo: 'Videoni ko\'rish'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      products: 'Продукты',
      about: 'О нас',
      news: 'Новости',
      contact: 'Связаться с нами'
    },
    pages: {
      home: {
        title: 'Bruce - Современные Решения',
        subtitle: 'Высококачественные продукты и услуги',
        featuredProducts: 'Популярные Продукты',
        featuredProductsSubtitle: 'Познакомьтесь с нашими самыми качественными и популярными продуктами',
        latestNews: 'Последние Новости',
        latestNewsSubtitle: 'Последние новости и информация о нашей компании',
        whyChooseUs: 'Почему выбирают нас?',
        whyChooseUsSubtitle: 'Мы обслуживаем с высоким качеством, надежным сервисом и профессиональным подходом',
        ourServices: 'Наши Услуги',
        productsTitle: 'Продукты',
        newsTitle: 'Новости',
        allProducts: 'Все Продукты',
        allNews: 'Все Новости',
        noProducts: 'Продукт не найден',
        noNews: 'Новость не найдена',
        featured: 'Главное',
        readMore: 'Подробнее'
      },
      products: {
        title: 'Продукты',
        subtitle: 'Откройте для себя высококачественные и надежные продукты. Каждый продукт изготовлен по профессиональным стандартам.',
        ourProducts: 'Наши Продукты',
        allProducts: 'Все Продукты',
        allCategories: 'Все категории',
        category: 'Категория',
        price: 'Цена',
        addToCart: 'Добавить в корзину',
        viewDetails: 'Подробнее',
        noProducts: 'Продукт не найден',
        noProductsDetails: 'продуктов не найдено.',
        productsFound: 'продуктов найдено',
        inCategory: 'в категории',
        searchQuery: 'по запросу',
        searchPlaceholder: 'Поиск продуктов...',
        filters: 'Фильтры',
        clearFilters: 'Очистить фильтры',
        sort: 'Сортировка',
        sortByName: 'По названию',
        sortPriceAsc: 'Цена: дешевые → дорогие',
        sortPriceDesc: 'Цена: дорогие → дешевые',
        sortNewest: 'Самые новые',
        ctaTitle: 'Не нашли интересующий продукт?',
        ctaDescription: 'Свяжитесь с нами, и мы вместе найдем подходящий продукт. Профессиональная консультация бесплатно!',
        backHome: 'Вернуться на главную',
        pagination: {
          previous: 'Предыдущая',
          next: 'Следующая',
          page: 'Страница',
          of: 'из',
          showing: 'Показано',
          to: 'до',
          results: 'результатов'
        },
        features: 'Характеристики Продукта',
        reviews: 'Отзывы Клиентов',
        noReviews: 'Пока нет отзывов об этом продукте. Оставьте первый отзыв!',
        otherProducts: 'Другие Продукты',
        orderModal: {
          title: 'Купить',
          firstName: 'Имя',
          lastName: 'Фамилия',
          phone: 'Номер телефона',
          cancel: 'Отменить',
          submit: 'Отправить',
          success: 'Ваш заказ успешно принят! Мы свяжемся с вами.',
          error: 'Произошла ошибка при оформлении заказа.'
        },
        reviewModal: {
          title: 'Оставить отзыв',
          name: 'Ваше имя',
          comment: 'Ваш отзыв',
          rating: 'Рейтинг (1-5)',
          cancel: 'Отменить',
          submit: 'Оставить отзыв',
          success: 'Ваш отзыв успешно добавлен!',
          error: 'Произошла ошибка при добавлении отзыва.'
        }
      },
      about: {
        title: 'О нас',
        subtitle: 'Компания Bruce Tank - ваш надежный партнер. Мы обслуживаем с профессиональным подходом и высоким качеством.',
        category: 'О нас',
        ourMission: 'Наша Миссия',
        ourVision: 'Наше Видение',
        ourTeam: 'Наша Команда',
        experience: 'Опыт',
        clients: 'Клиенты',
        projects: 'Проекты',
        noData: 'Информация не найдена',
        noDataDescription: 'В разделе "О нас" пока не добавлена информация.',
        addDataHint: 'Вы можете добавить информацию из панели администратора.',
        feature1: 'Качество',
        feature2: 'Доверие',
        feature3: 'Профессионал',
        ourValues: 'Наши Ценности',
        valuesDescription: 'Мы работаем на основе этих ценностей и служим нашим клиентам',
        value1Title: 'Целенаправленность',
        value1Description: 'Мы ставим четкие цели в каждом проекте и достигаем их',
        value2Title: 'Доверие',
        value2Description: 'Мы строим долгосрочные доверительные отношения с нашими клиентами',
        value3Title: 'Инновации',
        value3Description: 'Мы применяем новейшие технологии и методы',
        value4Title: 'Качество',
        value4Description: 'Мы соблюдаем высокие стандарты качества в каждом продукте',
        achievements: 'Наши Достижения',
        achievementsSubtitle: 'Успех, выраженный в цифрах и доверии клиентов',
        yearsExperience: 'Лет Опыта',
        happyClients: 'Довольных Клиентов',
        productTypes: 'Типов Продуктов',
        support: 'Поддержка'
      },
      news: {
        title: 'Новости',
        subtitle: 'Получите информацию о деятельности нашей компании и происходящих в отрасли новостях.',
        readMore: 'Читать далее',
        publishedOn: 'Опубликовано',
        noNews: 'Новости недоступны',
        noNewsDescription: 'Пока новостей нет. Скоро вернемся с новой информацией!',
        backToNews: 'К новостям',
        featured: 'Главная Новость',
        readTime: '2 минуты',
        available: 'новостей доступно',
        loadError: 'Произошла ошибка при загрузке новостей',
        ctaTitle: 'Будьте первыми в курсе новостей',
        ctaDescription: 'Следите за нами в социальных сетях и не пропускайте важные новости!'
      },
      contact: {
        title: 'Связаться с нами',
        subtitle: 'Есть вопросы? Свяжитесь с нами',
        name: 'Имя',
        email: 'Email',
        phone: 'Телефон',
        message: 'Сообщение',
        send: 'Отправить сообщение',
        address: 'Адрес',
        workingHours: 'Рабочие часы',
        monday: 'Понедельник',
        friday: 'Пятница',
        saturday: 'Суббота',
        sunday: 'Воскресенье',
        contactInfo: 'Контактная информация'
      }
    },
    footer: {
      description: 'Мы обслуживаем наших клиентов B2B и B2C высококачественными и надежными продуктами. Наши продукты производятся на основе современных технологий.',
      quickLinks: 'Быстрые ссылки',
      services: 'Наши услуги',
      home: 'Главная',
      about: 'О нас',
      products: 'Продукты',
      news: 'Новости',
      contact: 'Контакты',
      b2bSolutions: 'B2B решения',
      b2cProducts: 'B2C продукты',
      technicalSupport: 'Техническая поддержка',
      consulting: 'Консультационные услуги',
      delivery: 'Доставка',
      copyright: 'Все права защищены.',
      privacyPolicy: 'Политика конфиденциальности',
      termsOfUse: 'Условия использования',
      developer: 'Разработчик:'
    },
    common: {
      loading: 'Загрузка...',
      error: 'Произошла ошибка',
      tryAgain: 'Попробовать снова',
      readMore: 'Подробнее',
      contactUs: 'Свяжитесь с нами',
      backToHome: 'На главную',
      backHome: 'Вернуться на главную',
      reload: 'Перезагрузить',
      search: 'Поиск',
      filter: 'Фильтр',
      sort: 'Сортировка',
      featured: 'Популярное',
      inStock: 'В наличии',
      outOfStock: 'Нет в наличии',
      telegram: 'Телеграм',
      instagram: 'Инстаграм',
      productVideo: 'Видео продукта',
      videoLoading: 'Загрузка видео...',
      openOnYouTube: 'Открыть на YouTube',
      watchVideo: 'Смотреть видео'
    }
  }
};